import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0A0F2A]/90 backdrop-blur-md py-3 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-237">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-238">
        {/* Logo */}
        <a href="#" className="flex items-center" data-id="element-239">
          <img src="https://cdn.magicpatterns.com/uploads/nLYAQxxf2fUsZMfCEPYnRh/Group_9.svg" alt="ARMAR Solutions" className="h-8 md:h-10 w-auto" data-id="element-240" />
        </a>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-4" data-id="element-241">
          <Button variant="outline" size="sm" href="#program" data-id="element-242">
            Структура навчання
          </Button>
          <Button variant="primary" size="sm" href="#tariffs" data-id="element-243">
            Доєднатися до програми
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-244">
          {isMobileMenuOpen ? <X data-id="element-245" /> : <Menu data-id="element-246" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-[#0A0F2A] border-t border-white/10 p-4 flex flex-col gap-4 shadow-xl" data-id="element-247">
          <Button variant="outline" fullWidth href="#program" onClick={() => setIsMobileMenuOpen(false)} data-id="element-248">
            Структура навчання
          </Button>
          <Button variant="primary" fullWidth href="#tariffs" onClick={() => setIsMobileMenuOpen(false)} data-id="element-249">
            Доєднатися до програми
          </Button>
        </div>}
    </header>;
}